import React from "react";
import { Table, Button, Text } from "@nextui-org/react";
import { TbSortAscending } from "react-icons/tb";

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  return isNaN(d.getTime())
    ? dateStr
    : d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

const columns = [
  { key: "created", label: "Date" },
  { key: "type", label: "Type" },
  { key: "phone", label: "Phone/Ref" },
  { key: "qty", label: "Qty" },
  { key: "customer", label: "Customer" },
  { key: "customerPhone", label: "Cust Phone" },
  { key: "issue", label: "Issue/Note" },
  { key: "amount", label: "Sunil Amt" },
  { key: "customerAmount", label: "Cust Amt" },
  { key: "profit", label: "Profit" },
];

const AltAnalyticsTable = ({ processedList, row, onSort }) => {
  return (
    <Table aria-label="Alt Entries Analytics Table" compact sticked shadow={false}>
      <Table.Header>
        {columns.map((column) => (
          <Table.Column key={column.key} css={{ color: "black" }}>
            <div className="tableColumn">
              {column.label}&nbsp;&nbsp;&nbsp;
              <Button auto light size="xs" onClick={() => onSort(column.key)}>
                <TbSortAscending />
              </Button>
            </div>
          </Table.Column>
        ))}
      </Table.Header>
      <Table.Body css={{ textAlign: "start" }}>
        {processedList.map((doc) => {
          const isDeduction =
            doc.type === "deduction" || doc.recordType === "deduction";
          const q = isDeduction ? 1 : Number(doc.qty || 1);
          const sAmt = Number(doc.amount || 0) * q;
          const cAmt = Number(doc.customerAmount || 0) * q;
          const prof = cAmt - sAmt;

          return (
            <Table.Row key={doc._id} css={{ fontSize: "13px" }}>
              <Table.Cell>
                {formatDate(doc.created || doc.createdAt)}
              </Table.Cell>
              <Table.Cell>
                <Text
                  b
                  size="12px"
                  color={isDeduction ? "success" : "error"}
                >
                  {isDeduction ? "Deduction" : "Entry"}
                </Text>
              </Table.Cell>
              <Table.Cell>
                {doc.phone || (isDeduction ? "Deduction" : "-")}
              </Table.Cell>
              <Table.Cell>
                {isDeduction ? "-" : (doc.qty || 1)}
              </Table.Cell>
              <Table.Cell>{doc.customer || "-"}</Table.Cell>
              <Table.Cell>{doc.customerPhone || "-"}</Table.Cell>
              <Table.Cell>{doc.issue || doc.note || "-"}</Table.Cell>
              <Table.Cell>
                <Text
                  b
                  size="13px"
                  color={isDeduction ? "success" : "error"}
                >
                  {isDeduction ? "-" : "+"} &#8377;
                  {Math.ceil(sAmt).toLocaleString("en-IN")}
                </Text>
              </Table.Cell>
              <Table.Cell>
                {!isDeduction && cAmt > 0
                  ? `₹ ${Math.ceil(cAmt).toLocaleString("en-IN")}`
                  : "-"}
              </Table.Cell>
              <Table.Cell>
                {!isDeduction && cAmt > 0 && doc.category === "customer" ? (
                  <Text
                    b
                    size="13px"
                    color={prof >= 0 ? "secondary" : "error"}
                  >
                    &#8377;
                    {Math.ceil(prof).toLocaleString("en-IN")}
                  </Text>
                ) : (
                  "-"
                )}
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
      <Table.Pagination
        size="sm"
        color="error"
        shadow
        align="center"
        rowsPerPage={row}
      />
    </Table>
  );
};

export default AltAnalyticsTable;

